var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-form-toggle d-flex justify-end",class:{
    'message-form-toggle--radial-pulsating-animation': _vm.showAnimation
  }},[_c('div',{staticClass:"message-form-toggle__wrapper"},[_c('pp-button',{staticClass:"message-form-toggle__wrapper__btn pa-7 white--text text-h2",attrs:{"icon":_vm.showForm ? 'chevron-down' : 'chat',"type":"primary"},on:{"click":_vm.renderForm}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }